import { Dialog, DialogActions } from '@material-ui/core'
import { LoadingContainer } from 'components/Common/LoadingContainer'
import { LocalizedButton } from 'components/Localization/LocalizedButton'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ReactMarkdown from 'react-markdown'
import { connect } from 'react-redux'
import { RootAppState } from 'store/configureStore'
import { oldProjectActions } from 'store/Project/ProjectStore'
import { WorkingStepType } from '../../../../services/APIs/InternalAPI/internal-api.contracts'
import './CostPriceExplanationModal.sass'

type CostPriceExplanationModalProps = {
  projectId: string
  rowId: string
  workingStepType: WorkingStepType
  isActive: boolean
  onClose: () => void
  getCostPriceExplanation: (
    projectId: string,
    rowId: string,
    setData: (str: string) => void
  ) => void
  isLoading: boolean
  costPriceExplanation: string
  cleanCurrentCostPriceExplanation: () => void
}

const mapStateToProps = (state: RootAppState) => ({
  projectId: state.project.activeProject?.id,
  isLoading:
    state.app.currentNetworkAction === 'GetCostPriceExplanation' &&
    state.app.isLoading,
  costPriceExplanation: state.project.activeProject.costPriceExplanation,
})

const mapDispatchToProps = (dispatch) => ({
  getCostPriceExplanation: (
    projectId: string,
    rowId: string,
    setData: (str: string) => void
  ) =>
    dispatch(
      oldProjectActions.GetCostPriceExplanation(projectId, rowId, setData)
    ),
  cleanCurrentCostPriceExplanation: () =>
    dispatch(oldProjectActions.CleanCurrentCostPriceExplanation()),
})

const CostPriceExplanationModal = (props: CostPriceExplanationModalProps) => {
  const { t } = useTranslation()
  const emptyExplanation = t('common:no-available-data', 'no available data')
  const [costPriceExplanation, setCostPriceExplanation] = useState(null)
  const {
    getCostPriceExplanation,
    cleanCurrentCostPriceExplanation,
    projectId,
    rowId,
    workingStepType,
  } = props

  useEffect(() => {
    getCostPriceExplanation(projectId, rowId, setCostPriceExplanation)

    return () => cleanCurrentCostPriceExplanation()
  }, [
    cleanCurrentCostPriceExplanation,
    getCostPriceExplanation,
    projectId,
    rowId,
    workingStepType,
  ])

  return (
    <Dialog
      open={props.isActive}
      title="cost price"
      onClose={() => {
        props.onClose()
        props.cleanCurrentCostPriceExplanation()
      }}
      maxWidth={'md'}
      fullWidth
      id="costPriceExplanation-modal"
    >
      <div className="cost-price-explanation--body">
        <LoadingContainer loading={props.isLoading} noMessage variant="spinner">
          <div className="cost-price-explanation--formula">
            <ReactMarkdown>
              {costPriceExplanation || emptyExplanation}
            </ReactMarkdown>
          </div>
        </LoadingContainer>
      </div>
      <DialogActions>
        <LocalizedButton
          translationKey="common:close"
          color="secondary"
          onClick={() => props.onClose()}
        />
      </DialogActions>
    </Dialog>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CostPriceExplanationModal)
